import { render } from "./ChurchSettings.vue?vue&type=template&id=34e43018&scoped=true"
import script from "./ChurchSettings.vue?vue&type=script&lang=js"
export * from "./ChurchSettings.vue?vue&type=script&lang=js"

import "./ChurchSettings.vue?vue&type=style&index=0&id=34e43018&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e43018"]])

export default __exports__